import styled from 'styled-components'
import SearchableMultipleSelect from '@/components/content/SearchableMultipleSelect'
import { FloatingLabelWrapper } from '@/components/content/FloatingLabelWrapper'

export interface FloatingMultiSelectOption {
  value: string
  label: string
}

export interface FloatingMultiSelectProps {
  options: FloatingMultiSelectOption[]
  value: string[]
  onChange: (value: string[]) => void
  placeholder?: string
  /** 플로팅 라벨 — 미지정 시 라벨 없이 렌더(예: 패널 내부에서 라벨을 따로 그리는 경우) */
  floatingLabel?: string
  required?: boolean
  disabled?: boolean
  width?: number
  optionMaxHeight?: number
  /** 검색 입력 Enter 시 호출 — 필터 적용 트리거용 */
  onEnter?: () => void
}

/**
 * 플로팅 라벨 + (트리거에서 바로 타이핑하는) 검색 + 다중선택 셀렉트.
 * SearchableMultipleSelect 를 포털 모드로 사용하므로 overflow:hidden 컨테이너
 * (예: FilterListV2) 안에서도 드롭다운이 잘리지 않는다.
 */
export function FloatingMultiSelect({
  options,
  value,
  onChange,
  placeholder = '선택',
  floatingLabel,
  required = false,
  disabled = false,
  width,
  optionMaxHeight = 300,
  onEnter,
}: Readonly<FloatingMultiSelectProps>) {
  const select = (
    <Wrapper $width={width}>
      <SearchableMultipleSelect<string>
        usePortal
        filterOnlySearch
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        maxHeight={optionMaxHeight}
        onEnter={onEnter}
      />
    </Wrapper>
  )

  if (!floatingLabel) return select

  return (
    <FloatingLabelWrapper label={floatingLabel} required={required}>
      {select}
    </FloatingLabelWrapper>
  )
}

const Wrapper = styled.div<{ $width?: number }>`
  ${({ $width }) => ($width ? `min-width: ${$width}px; width: ${$width}px;` : 'width: 100%;')}

  input {
    height: 44px;
  }
`

export default FloatingMultiSelect
